import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AddressBookDto, BankDto, OwnershipTypeDto } from '@cradua/data';
import { SearchModalComponent } from '../../../../search-modal/search-modal.component';

@Component({
  selector: 'cradua-lessor-header',
  templateUrl: './lessor-header.component.html',
  styleUrls: ['./lessor-header.component.scss']
})
export class LessorHeaderComponent implements OnInit {

  @Input() activitySelectedValue: string;
  @Input() ownershipTypes: OwnershipTypeDto[];
  @Input() banks: BankDto[];
  @Output() emitAddressBook = new EventEmitter<any>();
  @Output() emitCreateAddressBook = new EventEmitter<any>();

  lessorTemForm: FormGroup;
  selectedAddressBook: AddressBookDto;

  constructor(
    public dialog: MatDialog,
    private fb: FormBuilder,
  ) { }

  ngOnInit(): void {
    this.lessorTemForm = this.fb.group({
      AddressBookName: ['', Validators.required],
      OwnershipTypeId: ['', Validators.required]
    });
  }

  onSelectOwnershipType(id: string) {
    console.log('id ', id);
  }

  onSubmit(value) {
    const lessor = {
      OwnershipTypeId: value.OwnershipTypeId,
      LandOwnershipTypeId: value.OwnershipTypeId,
      OwnershipTypeName: this.getAddressBookName(value.OwnershipTypeId),
      AddressBookId: this.selectedAddressBook.id,
      LandOwnershipTypeNameId: this.selectedAddressBook.id,
      LandOwnershipTypeName: this.selectedAddressBook.Name,
      PhoneNo: this.selectedAddressBook.PhoneNo,
      Email: this.selectedAddressBook.Email,
      AccountName: this.selectedAddressBook.AccountName,
      AccountNo: this.selectedAddressBook.AccountNo,
      VendorId: this.selectedAddressBook.VendorId,
      StateId: this.selectedAddressBook.StateId,
      LgaId: this.selectedAddressBook.LgaId,
      CommunityId: this.selectedAddressBook.CommunityId,
      BankName: this.getBankName(this.selectedAddressBook.BankId),
    }
    this.emitAddressBook.emit(lessor);
    this.lessorTemForm.reset();
  }


  getAddressBookName(id: string) {
    const found = this.ownershipTypes.find(own => own.id === id);
    return found ? found.OwnershipTypeName : '';
  }

 getBankName(id: string) {
    const found = this.banks.find(bank => bank.id === id);
    return found ? found.BankName : '';
  }

  createEvent() {}

  onSearchDialog() {

    const dialogConfig = new MatDialogConfig();

    // dialogConfig.disableClose = false;
    dialogConfig.id = "modal-component";
    dialogConfig.height = "90%";
    dialogConfig.width = "100%";
    // dialogConfig.minHeight = '100vh';
    // dialogConfig.minWidth = '100%'
    // dialogConfig.panelClass = "custom-dialog-container";
    // dialogConfig.backdropClass = "backdropBackground";


    const dialogRef = this.dialog.open(
      SearchModalComponent,
      dialogConfig,
    );

    dialogRef.afterClosed().subscribe((result: AddressBookDto) => {
      // console.log('result got ', result);
      if(result !== undefined && result['type'] === 'searchAddressBook') {
        this.selectedAddressBook = result;
        this.lessorTemForm.patchValue({AddressBookName: result.Name});
      } else if(result !== undefined && result['type'] === 'addressBook') {
        this.emitCreateAddressBook.emit(result);
      }

    });
  }


}
